import { useTranslation } from 'react-i18next';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

interface ServerErrorPageProps {
  onRetry?: () => void;
}

export function ServerErrorPage({ onRetry }: ServerErrorPageProps) {
  const { t } = useTranslation();

  return (
    <Stack spacing={2} sx={{ alignItems: 'center', textAlign: 'center' }}>
      <Typography variant="h1" color="primary">
        500
      </Typography>
      <Typography variant="h5">{t('errors.serverErrorTitle')}</Typography>
      <Typography variant="body1" color="text.secondary">
        {t('errors.serverErrorDescription')}
      </Typography>
      {onRetry && (
        <Button onClick={onRetry} variant="contained">
          {t('common.retry')}
        </Button>
      )}
    </Stack>
  );
}
